// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".facts[data-v-8782aeda]{margin-left:-4px;margin-right:-4px}@media(min-width:640px){.facts[data-v-8782aeda]{margin-left:-4px;margin-right:-4px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
